import { render, staticRenderFns } from "./ProductLabelBadge.vue?vue&type=template&id=969ac98c&scoped=true&"
import script from "./ProductLabelBadge.vue?vue&type=script&lang=js&"
export * from "./ProductLabelBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelBadge.vue?vue&type=style&index=0&id=969ac98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969ac98c",
  null
  
)

export default component.exports